module.exports = __webpack_public_path__ + "static/img/healthy-safety1.4c7bee7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/healthy-safety1.jpg
// module id = nfL3
// module chunks = 0